<template>
    <div class="MPCFooter">
        <v-container grid-list-md>
            <v-layout row wrap>
                <v-flex xs12 class="text-xs-center">
                    <Adsense
                            data-ad-client="ca-pub-1585481048202082"
                            data-ad-slot="2734382232"
                            data-ad-format="auto"
                            data-full-width-responsive="true"
                    ></Adsense>
                </v-flex>
                <v-flex xs12 text-xs-center>
                    &copy; 1996-
                    <current-year></current-year>
                    MODPlug Central
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import currentYear from '@/components/includes/currentYear';

    export default {
        name: "MPCFooter",
        components: {
            'current-year': currentYear
        }
    }
</script>

<style scoped>

</style>
